import { attachTooltip } from '../components/tooltip'

export default () => ({
  link(scope, element, attrs) {
    attachTooltip(element[0], attrs.ngTooltip, attrs.placement || 'top');
    scope.$on("$destroy", () => element.tooltip('hide'));
  }
})
